export default [
  {
    title: 'Reports',
    icon: 'GridIcon',
    route: 'page-layout-layout-empty',    
    children: [
      {
        title: 'Ticket Report',
        route: 'report-ticket', 
        icon: 'ClipboardIcon',
        permissionCode:'RP001',
      },
      {
        title: 'Accounting Report',
        route: 'report-accounting', 
        icon: 'FileTextIcon',
        permissionCode:'RP004',
      }
    ]            
  },
]


